(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.createMisuCartSync = factory;
})(typeof window === 'undefined' ? this : window, function (api, model) {
  'use strict';
  function isGiftLine(line) {
    return Boolean(line && line.properties && line.properties._misu_gift);
  }
  async function apply(cart, desired, scope, opts) {
    if (model.matches(cart, desired, scope)) return cart;
    var silentAll = Boolean(opts && opts.silent);
    var missing = desired.filter(function (line) { return !model.managed(cart, scope).some(function (i) { return model.identity(i) === model.identity(line); }); });
    var pouchLines = missing.filter(function (line) { return !isGiftLine(line); });
    var giftLines = missing.filter(isGiftLine);
    if (pouchLines.length) await api('/cart/add.js', { items: pouchLines }, silentAll ? { silent: true } : undefined);
    if (giftLines.length) await api('/cart/add.js', { items: giftLines }, { silent: true });
    // Read again because keys can change when Shopify applies discounts.
    cart = await api('/cart.js', null, { silent: true });
    var remaining = desired.slice(), updates = {};
    model.managed(cart, scope).forEach(function (item) {
      var index = remaining.findIndex(function (line) { return model.identity(item) === model.identity(line); });
      var qty = index < 0 ? 0 : remaining.splice(index, 1)[0].quantity;
      if (item.quantity !== qty) updates[item.key] = qty;
    });
    if (remaining.length) throw new Error('A pouch could not be added. Please try again.');
    if (Object.keys(updates).length) cart = await api('/cart/update.js', { updates: updates }, { silent: true });
    if (!model.matches(cart, desired, scope)) throw new Error('Your quantity could not be confirmed. Please try again.');
    return cart;
  }
  return async function synchronize(desired, scope, opts) {
    var before = await api('/cart.js', null, { silent: true });
    try { return await apply(before, desired, scope, opts); }
    catch (error) {
      try {
        var latest = await api('/cart.js', null, { silent: true });
        // A lost response can still represent an accepted operation.
        if (model.matches(latest, desired, scope)) return latest;
        await apply(latest, model.restoreLines(before, scope), scope, { silent: true });
      } catch (rollbackError) { error.unconfirmed = true; }
      throw error;
    }
  };
});
